<div class="service-enquiry-page">

  <!-- ================= HEADER ================= -->

  <div class="page-header">
    <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>

    <div class="header-left">

      <div class="header-icon">
        <span class="material-symbols-outlined">
          support_agent
        </span>
      </div>

      <div>
        <h1>My Enquiries</h1>
        <p>Track all your conversations with merchants</p>
      </div>

    </div>

  </div>



  <!-- ================= LAYOUT ================= -->

  <div class="enquiry-layout" [class.mobile-chat-open]="isMobileChatOpen">

    <!-- ================= LEFT PANEL ================= -->

<div class="enquiry-list">


<!-- SEARCH -->

<div class="search-box">

<span class="material-symbols-outlined">
search
</span>

<input
type="text"
placeholder="Search enquiries"
/>

</div>




<div
class="empty-state"
*ngIf="!enquiries.length">

<span class="material-symbols-outlined">
forum
</span>

<h3>No Enquiries Yet</h3>

<p>
Start an enquiry from any wedding service.
</p>

</div>





<div
class="enquiry-card"
*ngFor="let enquiry of enquiries"
(click)="selectEnquiry(enquiry)"

[class.active]="selectedEnquiry?._id===enquiry._id"
>




<div class="avatar">

<span class="material-symbols-outlined">
storefront
</span>

</div>




<div class="card-content">


<div class="card-top">

<h3>
{{enquiry.merchant_name}}
</h3>


<span class="time">

{{enquiry.messages[enquiry.messages.length-1]?.created_at 
| date:'hh:mm a'}}

</span>


</div>




<div class="service-name">
{{enquiry.service_name||'General Enquiry'}}
</div>

<p>
{{enquiry.messages[enquiry.messages.length-1]?.message}}
</p>



<div class="card-bottom">


<!-- <span class="status">

{{enquiry.status}}

</span> -->



<span
class="count unread"
*ngIf="enquiry?.user_unread_count>0">

{{enquiry?.user_unread_count}}

</span>


</div>



</div>


</div>


</div>



    <!-- ================= RIGHT PANEL ================= -->

    <div
      class="chat-panel"
      *ngIf="selectedEnquiry">

      <!-- Header -->

      <div class="chat-header">
         <!-- MOBILE BACK BUTTON -->
  <button
    class="mobile-chat-back"
    type="button"
    (click)="closeMobileChat()"
  >
    <span class="material-symbols-outlined">
      arrow_back
    </span>
  </button>


<div class="avatar large">

<span class="material-symbols-outlined">
storefront
</span>

</div>


<div class="header-details">

<h2>
{{selectedEnquiry.merchant_name}}
</h2>

<p>
{{selectedEnquiry.service_name||'General Enquiry'}}
</p>

</div>


<button
class="service-details-btn"
(click)="showServiceDetails=true"
*ngIf="selectedEnquiry?.service_id && selectedEnquiry?.service_details">

<span class="material-symbols-outlined">
info
</span>

Service Details

</button>


</div>



      



      <!-- MESSAGES -->

      <div class="messages" #chatContainer>

        <div
          *ngFor="let msg of selectedEnquiry.messages"
          class="message"
          [ngClass]="{

            'user':msg.sender_type==='USER',

            'merchant':msg.sender_type==='MERCHANT'

          }">

          <div class="bubble">
            <div class="sender">

{{msg.sender_type==="USER" ? "You" : msg.sender_name}}

</div>


<p>
{{msg.message}}
</p>


<div class="message-info">

<span>
{{msg.created_at | date:'hh:mm a'}}
</span>


<span 
*ngIf="msg.sender_type==='USER'"
[class.read]="msg.status==='READ'">

{{msg.status==='SENT' ? '✓':'✓✓'}}

</span>


</div>


</div>

        </div>

      </div>



      <!-- REPLY -->

      <div class="reply-box">

        <textarea

          [(ngModel)]="replyMessage"

          placeholder="Type your message...">

        </textarea>



        <button

          (click)="sendReply()">

          <span class="material-symbols-outlined">

            send

          </span>

          Send

        </button>

      </div>

    </div>



    <!-- PLACEHOLDER -->

    <div
      class="chat-placeholder"
      *ngIf="!selectedEnquiry">

      <span class="material-symbols-outlined">

        forum

      </span>

      <h2>

        Select an Enquiry

      </h2>

      <p>

        Choose an enquiry from the left panel to view the conversation.

      </p>

    </div>

  </div>
  <!-- SERVICE DETAILS POPUP -->

<div 
class="overlay"
*ngIf="showServiceDetails"
(click)="showServiceDetails=false">


<div 
class="service-modal"
(click)="$event.stopPropagation()">



<div class="modal-header">


<h2>
Service Details
</h2>


<button
(click)="showServiceDetails=false">

✕


</button>


</div>



<div class="service-content">


<h3>
{{selectedEnquiry.service_details.service_name}}
</h3>


<p>
{{selectedEnquiry.service_details.description}}
</p>



<div class="detail-row">

<span>
💰 Price
</span>

<b>
₹{{selectedEnquiry.service_details.price}}
</b>

</div>




<div class="detail-row">

<span>
⏱ Duration
</span>

<b>
{{selectedEnquiry.service_details.duration}}
</b>

</div>




<div class="detail-row">

<span>
📍 Location
</span>

<b>
{{selectedEnquiry.service_details.service_locations.join(', ')}}
</b>

</div>



<div class="included">


<h4>
Included
</h4>


<div
*ngFor="let item of selectedEnquiry.service_details.included">

✓ {{item}}

</div>


</div>



</div>


</div>


</div>

</div>